module.exports = __webpack_public_path__ + "static/media/pagging-gfs.d22d2dfa.svg";